var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankCardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3956_70401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5759 4.02539H1.70979C0.844383 4.02539 0.142822 4.72695 0.142822 5.59235V20.4082C0.142822 21.2736 0.844383 21.9751 1.70979 21.9751H24.5759C25.4413 21.9751 26.1428 21.2736 26.1428 20.4082V5.59235C26.1428 4.72695 25.4413 4.02539 24.5759 4.02539Z",
    fill: "#1D5095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1711 8.39742V10.9494C18.1711 11.3502 18.496 11.675 18.8967 11.675H22.8998C23.3006 11.675 23.6254 11.3501 23.6254 10.9494V8.39742C23.6254 7.99667 23.3005 7.67188 22.8998 7.67188H18.8967C18.496 7.67188 18.1711 7.99673 18.1711 8.39742Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71265 6.59961H3.84055C4.0638 6.59961 4.23031 6.60894 4.34002 6.62754C4.44973 6.64614 4.54789 6.68494 4.6345 6.74396C4.72111 6.80298 4.79329 6.8816 4.85103 6.97976C4.90877 7.07792 4.93764 7.18796 4.93764 7.30983C4.93764 7.44197 4.90205 7.56323 4.83082 7.6736C4.75959 7.78398 4.66304 7.86671 4.54117 7.92189C4.71312 7.97192 4.84526 8.05725 4.93764 8.1779C5.03003 8.29849 5.07622 8.44029 5.07622 8.60325C5.07622 8.73155 5.04641 8.85637 4.98672 8.97762C4.92704 9.09888 4.84559 9.19576 4.74227 9.26828C4.639 9.34079 4.51163 9.38537 4.36023 9.40202C4.26529 9.4123 4.03621 9.41868 3.6731 9.42129H2.71265V6.59961ZM3.28235 7.0692V7.72169H3.65572C3.8777 7.72169 4.01566 7.71847 4.06952 7.71208C4.16701 7.70053 4.24369 7.66683 4.29954 7.61103C4.3554 7.55523 4.38327 7.48178 4.38327 7.39067C4.38327 7.30339 4.35923 7.23255 4.31109 7.17797C4.26295 7.12339 4.19144 7.09041 4.0965 7.07887C4.04004 7.07242 3.87775 7.06926 3.60953 7.06926H3.28235V7.0692ZM3.28235 8.19134V8.94587H3.80974C4.01505 8.94587 4.14531 8.94009 4.20044 8.92854C4.28511 8.91316 4.35412 8.87563 4.40736 8.81595C4.46061 8.75626 4.48726 8.67642 4.48726 8.57632C4.48726 8.49165 4.46672 8.41975 4.42569 8.36073C4.38466 8.30171 4.3253 8.25874 4.24763 8.23176C4.16996 8.20477 4.00156 8.19134 3.74239 8.19134H3.28235Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10185 9.42129H7.48207L7.23572 8.78036H6.10782L5.87491 9.42129H5.27051L6.36954 6.59961H6.972L8.10185 9.42129ZM7.05284 8.30493L6.66403 7.25786L6.28293 8.30493H7.05284Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40991 9.42129V6.59961H8.96423L10.1191 8.48393V6.59961H10.6483V9.42129H10.0767L8.93919 7.58122V9.42129H8.40991Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2585 9.42129V6.59961H11.8282V7.8526L12.9792 6.59961H13.7453L12.6829 7.69864L13.8031 9.42129H13.0659L12.2902 8.09706L11.8282 8.5686V9.42129H11.2585Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76918 18.0215H1.56128V19.3981H3.76918V18.0215Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04524 18.0215H5.5647V19.3981H9.04524V18.0215Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0297 18.0215H10.0989V19.3981H14.0297V18.0215Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9109 18.0215H15.3301V19.3981H19.9109V18.0215Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7241 18.0215H21.4121V19.3981H24.7241V18.0215Z",
    fill: "#EBF0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3956_70401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.142822)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardLogo);
export default __webpack_public_path__ + "static/media/bank-card-logo.131b4d3a08c17feeb84999c0a812e367.svg";
export { ForwardRef as ReactComponent };